import { render, staticRenderFns } from "./emailsList.vue?vue&type=template&id=55b09de3&scoped=true&"
import script from "./emailsList.vue?vue&type=script&lang=js&"
export * from "./emailsList.vue?vue&type=script&lang=js&"
import style0 from "./emailsList.vue?vue&type=style&index=0&id=55b09de3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b09de3",
  null
  
)

export default component.exports